import axiosInstance from "../../lib/axiosInstance";
import { AppDispatch } from "../store";
import { auditLogActions } from "../slices/auditLog";
import { getErrorMessage } from "../../utils/errorUtils";
import { AuditLogResponseDto } from "../../shared/dtos/auditLog/AuditLogResponseDto";
import { AuditLogQueryDto } from "../../shared/dtos/auditLog/AuditLogQueryDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { PaginatedResponse } from "../../shared/dtos/common/PaginatedResponse";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getAuditLogs =
  (params?: AuditLogQueryDto) => async (dispatch: AppDispatch) => {
    dispatch(auditLogActions.setLoading());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<PaginatedResponse<AuditLogResponseDto>>
      >("/audit-logs", { headers: { requiresAuth: true }, params });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(auditLogActions.setItems(data.data.content));
        dispatch(auditLogActions.setPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(auditLogActions.setError(getErrorMessage(error)));
    }
  };
